import { getConfig } from '@cian/config/browser';
import { IYmaps } from './types';

declare const window: Window & {
  ymaps: IYmaps;
};

export function insertScriptToLoadYmaps(): Promise<IYmaps> {
  return new Promise((resolve, reject) => {
    const config = getConfig();
    const apiKey = config.getStrict<string>('builders.YandexApiKey');

    if (window.ymaps) {
      resolve(window.ymaps);

      return;
    }

    const scriptTag = window.document.createElement('script');

    const clean = () => window.document.body.removeChild(scriptTag);

    scriptTag.src = `https://enterprise.api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru-RU&load=Map`;
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.onload = () => {
      window.ymaps.ready(() => {
        resolve(window.ymaps);
        clean();
      });
    };
    scriptTag.onerror = () => {
      reject(new Error('Unable to load Yandex Maps API'));
      clean();
    };
    window.document.body.appendChild(scriptTag);
  });
}
